import { forwardRef, useState } from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  type TextFieldProps,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

type PasswordTextFieldProps = TextFieldProps;

const PasswordTextField = forwardRef<HTMLInputElement, PasswordTextFieldProps>(
  (props, ref) => {
    const [showPassword, setShowpassword] = useState(false);
    const { disabled, ...rest } = props;
    return (
      <TextField
        inputRef={ref}
        {...rest}
        type={showPassword ? "text" : "password"}
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowpassword((prev) => !prev)}
                edge="end"
                aria-label="パスワードの表示切替"
                size="large"
                tabIndex={-1}
                disabled={disabled}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  }
);

export default PasswordTextField;
